function _0x3610(_0x4b03c0, _0x1c404a) {
  const _0x4e1226 = _0x4e12();
  return (
    (_0x3610 = function (_0x3610b4, _0x3a4202) {
      _0x3610b4 = _0x3610b4 - 0x172;
      let _0x53ba3a = _0x4e1226[_0x3610b4];
      return _0x53ba3a;
    }),
    _0x3610(_0x4b03c0, _0x1c404a)
  );
}
function _0x4e12() {
  const _0x40553b = [
    "404756vQPykQ",
    "error",
    "7877016VEXIUI",
    "POST",
    "35OVXTCv",
    "1764610KwEsGm",
    "Error\x20en\x20la\x20solicitud:",
    "524301vSYljy",
    "25750485GZxHOu",
    "7770224vvxQEd",
    "1SHgjfT",
    "https://formsubmit.co/ajax/2eac9912cf3a6e36fceb989d7c45decd",
    "1400160CgzQsf",
  ];
  _0x4e12 = function () {
    return _0x40553b;
  };
  return _0x4e12();
}
const _0x500bc7 = _0x3610;
(function (_0x35fdf8, _0x4a4e1d) {
  const _0x5f4e1a = _0x3610,
    _0x119da7 = _0x35fdf8();
  while (!![]) {
    try {
      const _0x27011a =
        (-parseInt(_0x5f4e1a(0x17b)) / 0x1) *
          (-parseInt(_0x5f4e1a(0x176)) / 0x2) +
        -parseInt(_0x5f4e1a(0x178)) / 0x3 +
        (parseInt(_0x5f4e1a(0x17e)) / 0x4) *
          (parseInt(_0x5f4e1a(0x175)) / 0x5) +
        parseInt(_0x5f4e1a(0x173)) / 0x6 +
        parseInt(_0x5f4e1a(0x17a)) / 0x7 +
        -parseInt(_0x5f4e1a(0x17d)) / 0x8 +
        -parseInt(_0x5f4e1a(0x179)) / 0x9;
      if (_0x27011a === _0x4a4e1d) break;
      else _0x119da7["push"](_0x119da7["shift"]());
    } catch (_0x2ec7e9) {
      _0x119da7["push"](_0x119da7["shift"]());
    }
  }
})(_0x4e12, 0xc3ef0);
const apiUrl = _0x500bc7(0x17c);
export default {
  async sendEmail(_0x237ab6) {
    const _0x1ed22e = _0x500bc7;
    try {
      const _0x31c5a4 = await fetch(apiUrl, {
        method: _0x1ed22e(0x174),
        body: _0x237ab6,
      });
      return _0x31c5a4["ok"]
        ? !![]
        : (console[_0x1ed22e(0x172)](
            "Error\x20en\x20la\x20solicitud:" +
              _0x31c5a4["status"] +
              "-" +
              _0x31c5a4["statusText"]
          ),
          ![]);
    } catch (_0x34fdfb) {
      return console["error"](_0x1ed22e(0x177), _0x34fdfb), ![];
    }
  },
};